import { GET_ACCESS_GROUP_VALUE, GET_ACCESS_GROUP_VALUE_ERROR, GET_ACCESS_GROUP_VALUE_SUCCESS, UPDATE_ACCESS_GROUP_VALUE, UPDATE_ACCESS_GROUP_VALUE_ERROR, UPDATE_ACCESS_GROUP_VALUE_SUCCESS } from "./actiontype"

export const getallAcessGroup = () => {
    return {
      type: GET_ACCESS_GROUP_VALUE,
    }
  }
  export const getAccessgroupSuccess = value => {
    return {
      type: GET_ACCESS_GROUP_VALUE_SUCCESS,
      payload:value,
    }
  }
  export const getAccessgroupError = error => {
    return {
      type: GET_ACCESS_GROUP_VALUE_ERROR,
      payload: error,
    }
  }
export const onupdateAccess = (data,callback) => {
    return {
      type: UPDATE_ACCESS_GROUP_VALUE,
      payload: data,
      callback
    }
  }
  export const onupdateAccessSuccess = value => {
    return {
      type: UPDATE_ACCESS_GROUP_VALUE_SUCCESS,
      payload:value,
    }
  }
  export const onupdateAccessError = error => {
    return {
      type: UPDATE_ACCESS_GROUP_VALUE_ERROR,
      payload: error,
    }
  }